import { computed, inject } from 'vue';

export default function useVistaraSpecialPromo() {
  const moment = inject('moment');

  const vistaraMilesCount = computed(() => {
    const isBonusTime = moment().isBefore('2023-04-01T00:00:00+0530');

    return isBonusTime ? 10 : 6;
  });

  return {
    vistaraMilesCount,
  };
}
